import React, {FC, PropsWithChildren} from 'react';

import {AppContentTypesEnum} from '../../../store/panels/app/parameters/appParameters';
import {ExpandedDarkThemeProvider} from '../../common/theme/expandedDarkThemeProvider';

interface TopBarExpandedDarkThemeProviderProps {
  appContentType?: AppContentTypesEnum;
}

export const TopBarExpandedDarkThemeProvider: FC<PropsWithChildren<TopBarExpandedDarkThemeProviderProps>> = ({
  children,
  appContentType,
}) => {
  if (appContentType === AppContentTypesEnum.INBOXES) {
    return <ExpandedDarkThemeProvider>{children}</ExpandedDarkThemeProvider>;
  }

  return <>{children}</>;
};
